import { useParams } from 'react-router-dom';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';

interface Props {
  groupId: string;
  subscriberId: string;
  entityId: string;
}

const useSubscriberTaskUrlParams = (): Props => {
  const { groupId } = useParams<{ groupId: string }>();

  const query = useQueryParams();
  const subscriberId = query.get('subId') || '';
  const entityId = query.get('entityId') || '';

  return { groupId, subscriberId, entityId };
};

export default useSubscriberTaskUrlParams;
